<template>
  <div>
    <div class="top-btn">
      <vxe-toolbar perfect v-if="this.$slots.btn">
        <template v-slot:buttons>
          <slot name="btn"></slot>
        </template>
      </vxe-toolbar>
    </div>
    <vxe-grid
      border
      stripe
      show-overflow
      highlight-current-row
      row-id="id"
      auto-resize
      row-key
      ref="xTree"
      :resizable="resizable"
      :loading="loading"
      :data.sync="list"
      :columns="columns"
      :keyboard-config="{isArrow: true, isDel: true, isTab: true, isEdit: true}"
      :edit-config="editConfig"
      :tree-config="{children: 'children'}"
      :context-menu="{header: {options: headerMenus}, body:{options: bodyMenus},visibleMethod}"
      @context-menu-click="contextMenuClickEvent"
      @edit-closed="editClosed"
      @edit-actived="editActived"
      @cell-click="cellClickEvent"
      @cell-dblclick="cellDblClick"
      :show-footer="showfooter"
      :footer-method="footerMethod">
    </vxe-grid>
    <div v-if="showPage">
      <vxe-pager
        :loading="loading"
        :current-page="tablePage.currentPage"
        :page-size="tablePage.pageSize"
        :total="tablePage.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="handlePageChange">
      </vxe-pager>
    </div>
    <el-dialog :visible.sync="browsForm" width="80%" :close-on-click-modal="false" :show-close="true" :destroy-on-close="true" :before-close="browsClose">
      <brows ref="brows" :browscode="browscode" :multiLine="addNewMultiLine" @closeDialog="closeDialog" @sureDialog="sureDialog"></brows>
    </el-dialog>
  </div>
  <!--:pager-config="tablePage"-->
  <!--@page-change="handlePageChange"-->

</template>
<script>
  import XEUtils from 'xe-utils'
  import request from  '@/utils/request'
  import * as calUtils from '../../assets/js/calUtils'
  import lebcquery from '../common/lebcquery'
  import brows from '../common/brows'
  export default {
    components: {brows},
    name: "vggrid",
    props:{
      tableheight: 0,
      flexname: '',
      resizable: {},
      list: {},
      cols: {},
      total: 0,
      showfooter: {},
      showPage: {},
      needRowNum:false,
      needSelection: false,
      needBlackRow: true,
      needPopMenu: true,
      canbeEdit: false
    },
    data () {
      return {
        loading: false,
        tableData: [],
        columns: [],
        editConfig: {},
        currow: {},
        curcol: {},
        customCols:[],
        sumcols: [],
        headerMenus: [
          [
            {
              code: 'showAllColumn',
              name: '取消所有隐藏列'
            },
            {
              code: 'hideColumn',
              name: '隐藏列'
            }
          ]],
        bodyMenus: [],
        tablePage: {
          total: this.total,
          currentPage: 1,
          pageSize: 10
        },
        browsForm: false,
        browscode: '',
        triggercols: [],
        toolbar: {
          id: 'vggridtoolbar',
          refresh: true,
          resizable: {
            storage: true
          },
          setting: {storage: true}
        },
        addNewMultiLine: false
      }
    },
    async created () {
      //通过flexname获取columns,否则，从外面获取表格
//      console.log('vggrid created')
//      this.init()
      //此处加载对应的下拉框数据
    },
    async activated () {
      //通过flexname获取columns,否则，从外面获取表格
      this.init()
      //此处加载对应的下拉框数据
    },
    mounted () {
//      if (this.needBlackRow && this.canbeEdit) {
//        setTimeout(() => {
//          this.$refs.xTree.insertAt({isadd: true}, -1)
//            .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
//        }, 300)
//      }
//      if (this.canbeEdit) {
//        setTimeout(() => {
//          this.editConfig = {trigger: 'click', mode: 'cell', showStatus: true}
//        },300)
//      }
//      if (!this.needPopMenu || !this.canbeEdit) {
//        this.bodyMenus = []
console.log('==-=-=-=-=cols',this.cols);

//      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'reportQuery') {
          if (to.query.reportid!==from.query.reportid) {
            this.init()
          }
        }
      },
      total (val1,val2) {
        this.tablePage.total = val1
      },
      pageSize (val1,val2) {
        this.tablePage.pageSize = val1
      },
      list () {
//        this.setSelectRows()
      }
    },
    methods: {
      async init() {
        setTimeout(() => {
          if (this.flexname) {
            this.getFlexcols()
          } else {
            this.columns = this.cols
            this.loadComboData()
            this.setSelectRows()
            this.getTriggercols()
            this.setCustomColumns()
          }
          this.headerMenus = []
          if (this.needBlackRow && this.canbeEdit) {
            console.log(this.needBlackRow , this.canbeEdit,this.$refs.xTree)
            this.$refs.xTree.insertAt({isadd: true}, -1)
              .then(({row}) => this.$refs.xTree.setActiveCell(row, this.activeCell))
          }
          if (this.canbeEdit) {
            this.editConfig = {trigger: 'click', mode: 'cell', showStatus: true}
          } else {
            this.editConfig = {}
          }
          if (!this.needPopMenu || !this.canbeEdit) {
            this.bodyMenus = []
          } else {
            this.bodyMenus = [
              [
                {
                  code: 'addBlackRows',
                  name: '添加行'
                },
                {
                  code: 'addFiveBlackRows',
                  name: '添加5行'
                },
                {
                  code: 'removeBlackRows',
                  name: '删除行'
                },
                {
                  code: 'insertBlackRows',
                  name: '插入行'
                },
                {
                  code: 'insertFiveBlackRows',
                  name: '插入5行'
                }
              ]
            ]
          }
        },50)
      },
      async getFlexcols() {
        this.columns= []
        let flexcols = await request({
          url: '/kfgl/flex/getFlexcolListByFlexcode',
          method: "get",
          params: {flexcode: this.flexname, comid: this.$store.getters.loginUser.usercomid}
        })
        let column = {}
        if (this.needSelection) {
          column = { type: 'checkbox',fieldtype: 'I', title: '选择',calculExpr:'', width: 80 }
          this.columns.push(column)
        }
        if (this.needRowNum) {
          column = { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 ,treeNode:'true'}
          this.columns.push(column)
        }
        await (async ()=>{
          for (let i=0;i<flexcols.length;i++) {
            column = {}
            let item = flexcols[i]
            column.field = item.flexcolcode
            column.title = item.flexcolname
            column.fieldtype = item.flexcoltype
            column.hide = item.flexcolhide
            column.brows = item.flexcolbrows
            column.getvaluestr = item.flexcolgetvaluestr
            column.setvaluestr = item.flexcolsetvaluestr
            column.calculExpr = item.flexcolcalculexpr
            column.issum = item.flexcolissum
            column.triggercol = item.flexcolgriggercol
            column.flexcoleditflg = item.flexcoleditflg
            if (item.flexcoleditflg === '2') {
              if (this.canbeEdit) {
                column.editRender = { name: 'input'}
              }
            }
            if (item.flexcoleditflg === '3') {
              let res = []
              if (item.flexcolsyscode) {
                res = await request({
                  url: '/kfgl/syscode/getSysCodeList',
                  method: "get",
                  params: {syscode:item.flexcolsyscode}
                })
              }
              if (item.flexcolbrows) {
                res = await request({
                  method: 'get',
                  url: '/kfgl/brows/getBrowsDataList',
                  params: ({comid: this.$store.getters.loginUser.usercomid,browscode: item.flexcolbrows})
                })
              }
              res.splice(0,0, {
                label: '请选择',
                value: 0
              })
              column.editRender = {name: 'ElSelect',props: {disabled: !this.canbeEdit}, options: res}
            }
            if (item.flexcoleditflg === '4') {
              if (this.canbeEdit) {
                column.editRender = {name: 'ElInput', props: {readonly: true, suffixIcon: 'el-icon-search'}}
              }
            }
            if (item.flexcoleditflg === '5') {
              if (this.canbeEdit) {
                column.editRender = {name: 'ElSwitch'}
              }
            }
            if (item.flexcolhide === '1') {
              this.customCols.push(
                {
                  field: item.flexcolcode,
                  visible: false
                }
              )
            }
            if (item.flexcolissum === '1') {
              this.sumcols.push(item.flexcolcode)
            }
            this.columns.push(column)
          }
        })()
        await this.setSelectRows()
        await this.getTriggercols()
        await this.loadComboData()
        await this.reloadCustomColunms()

//        this.columns = [
//          { type: 'selection',calculExpr:'', width: 60 },
//          { type: 'index', title: '行号',calculExpr:'', width: 80 },
//          { field: 'lecode', title: '货物编码',calculExpr:'', minWidth: 140, editRender: { name: 'ElInput', props: { readonly: true,suffixIcon: 'el-icon-search'}},sortable:true},
//          { field: 'lename', title: '货物名称',calculExpr:'', minWidth: 140},
//          { field: 'leunitid', title: '计量单位',calculExpr:'', minWidth: 140, editRender: { name: 'ElSelect',options: [] } },
//          { field: 'ledate', title: '交货日期',calculExpr:'', width: 250, editRender: { name: 'ElDatePicker', props: { type: 'date', format: 'yyyy/MM/dd' } } ,sortable:true},
//          { field: 'leqty', title: '数量',calculExpr:'', triggercol: 1, width: 160, editRender: { name: 'ElInput'} },
//          { field: 'leprice', title: '单价',calculExpr:'', triggercol: 1,width: 160, editRender: { name: 'ElInput'} },
//          { field: 'leamt', title: '金额', calculExpr:'leqty*leprice', width: 160},
//          { field: 'remark', title: '备注',calculExpr:'', width: 200}
//        ]
      },
      async reloadCustomColunms() {
        let that = this
        setTimeout(() => {
          that.$refs.xTree.reloadCustoms(this.customCols)
        }, 50)
      },
      async setCustomColumns() {
        this.customCols = []
        this.columns.forEach(item => {
          if (item.hide === '1') {
            this.customCols.push(
              {
                field: item.field,
                visible: false
              }
            )
          }
          if (item.issum === 1) {
            this.sumcols.push(item.field)
          }
        })
        this.reloadCustomColunms()
      },
      async setSelectRows() {
        //可能存在多层的情况，需要完善
        let that = this
        let checkRowKeys = []
        setTimeout(() => {
          that.list.forEach(item => {
            item.children.forEach(k => {
              if (k.selected) {
                checkRowKeys.push(k)
              }
            })
          })
          that.$refs.xTree.setSelection(checkRowKeys,true)
        }, 300)
      },
      async loadComboData () {
        // let options = [{value: 1,label: 'pcs'},{value: 2,label: '箱'},{value: 3,label: '件'}]
        //this.columns[this.findTableColumnIndexByField('fieldtype')].editRender.options = this.options
        this.columns.forEach(async item => {
          if (item.syscode) {
            let options = await request({
              url: '/kfgl/syscode/getSysCodeList',
              method: "get",
              params: item
            })
            options.splice(0,0, {
              label: '请选择',
              value: 0
            })
            this.columns[this.findTableColumnIndexByField(item.field)].editRender.options = options
          }
        })

      },
      cellClickEvent(row,rowIndex,$rowIndex,column,columnIndex,$columnIndex,cell) {
        // 这里可以增加帮助器的弹出层选择数据比较多的录入项
        this.currow = row
        this.curcol = row.column
        this.$emit('cellClick', row, this.$refs.xTree)
        this.dialogVisible = true

      },
      cellDblClick(row,rowIndex,$rowIndex,column,columnIndex,$columnIndex,cell) {
        this.$emit('cellDblClick', row, this.$refs.xTree)
        this.dialogVisible = true
      },
      findTableColumnIndexByField(field) {
        let columnIndex = this.columns.findIndex(item => item.field === field)
        return columnIndex
      },
      closeDialog() {
        this.browsForm = false
      },
      sureDialog(selectRecords, insertflg) {
        if (selectRecords.length === 0) {
          this.$message.warning('至少需要选择一行！')
          return
        }
        let records = []
        let setvaluestr = this.curcol.own.setvaluestr
        let getvaluestr = this.curcol.own.getvaluestr
        if (selectRecords) {
          selectRecords.forEach(res => {
            let record = {}
            if (setvaluestr && getvaluestr) {
              let setarr = setvaluestr.split(',')
              let getarr = getvaluestr.split(',')
              for (let i=0;i<setarr.length;i++) {
                record[setarr[i]] = res[getarr[i]]+''
              }
              records.push(record)
            }
          })
        }
        if (records) {
          if (insertflg) {
            this.$refs.xTree.insertAt(records,this.currow.row)
              .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
          } else {
            this.$refs.xTree.reloadRow(this.currow.row, records[0])
          }
        }
        this.closeDialog()
      },
      editActived({row,rowIndex,$rowIndex,column,columnIndex,$columnIndex,cell}) {
        this.currow = row
        this.curcol = column
        this.browscode = column.own.brows
        if (this.browscode && column.own.flexcoleditflg == 4) {
          this.addNewMultiLine = row.isadd?true:false
          this.browsForm = true
        }
      },
      browsClose(done) {
        done()
      },

      editClosed (row) {
        let that  = this
        /*        if (that.columns[row.columnIndex].addNewRowFlg) {
                  if (that.list.length === row.rowIndex+1 && that.list[row.rowIndex][that.columns[row.columnIndex].field]) {
                    that.list.push({
                    })

                  }
                }*/
        if (that.columns[row.columnIndex].triggercol ===1) {
          that.columns.forEach(function (item,index,arr) {
            if (arr[index].calculExpr !=='') {
              that.calculColValue(arr[index].field,arr[index].calculExpr, that.triggercols ,row)
            }
          })
        }

      },
      //获取触发列数组
      getTriggercols() {
        this.columns.forEach(item => {
          if (item.triggercol === 1) {
            this.triggercols.push(item.field)
          }
        })
      },

      calculColValue (calField,expr, triggerCols, row) {
        let that = this
        let rowIndex = row.rowIndex
        triggerCols.forEach(function (item, index) {
          let colValue = row.row[item]
          expr = expr.replace(item, colValue)
        })
        let result = calUtils.calStr(expr)
        if (result) {
          that.setValueToCell(row,calField,result)
        }
      },
      setValueToCell (row,calField,val) {
        row.row[calField] = Number(Number(val).toFixed(2))
        this.$refs.xTree.updateFooter()
      },
      getObjectValueByKeyStr(obj,field) {
        let value
        Object.keys(obj).forEach(function (key, index) {
          if (key === field) {
            let values = Object.values(obj)
            value = values[index]
          }
        })
        return value
      },
      handlePageChange ({ currentPage, pageSize }) {
        this.tablePage.currentPage = currentPage
        this.tablePage.pageSize = pageSize
        this.$emit('pagechange', this.tablePage)
      },
      visibleMethod ({ type, options, column }) {
        // 显示之前处理按钮的操作权限
        options.forEach(list => {
          list.forEach(item => {
            if (['copy'].includes(item.code)) {
              item.disabled = isDisabled
            }
            if (['clear'].includes(item.code)) {
              item.visible = isVisible
            }
          })
        })
        return true
      },
      contextMenuClickEvent ({ menu, row, column }) {
        let xTree = this.$refs.xTree
        switch (menu.code) {
          case 'removeBlackRows':
            this.$refs.xTree.remove(row)
            break
          case 'insertBlackRows':
            this.$refs.xTree.insertAt({},row)
              .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
            break
          case 'insertFiveBlackRows':
            for (let i=0;i<5;i++) {
              this.$refs.xTree.insertAt({},row)
                .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
            }
            break
          case 'addBlackRows':
            this.$refs.xTree.insertAt({}, -1)
              .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
            break
          case 'addFiveBlackRows':
            for (let i=0;i<5;i++) {
              this.$refs.xTree.insertAt({}, -1)
                .then(({ row }) => this.$refs.xTree.setActiveCell(row, this.activeCell))
            }
            break
          case 'hideColumn':
//            this.$refs.xTree.hideColumn(column)
            column.visible=false
            this.$refs.xTree.refreshColumn()
            break
          case 'showAllColumn':
            let that = this
            let columns = that.$refs.xTree.getTableColumn()
            that.$refs.xTree.getTableColumn().forEach(function (item) {
              item.visible= true
            })
            that.$refs.xTree.refreshColumn()
            break
        }
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计'
            }
            //合计列需要放到表格头部存储
            if (this.sumcols.includes(column.property)) {
              return XEUtils.sum(data, column.property)
            }
            return ''
          })
        ]
      }
    }
  }

</script>
